import { getArchetypes } from "@/features/branding";
import { internalApi } from "@/store/services/internal";
import { useEffect, useState } from "react";

const useArchetypes = (selectedPostId?: string) => {
  const [selectedArchetypeKey, setSelectedArchetypeKey] = useState<string>(selectedPostId || "home");
  const archetypes = getArchetypes();

  const selectedArchetype = selectedPostId
    ? archetypes.find((archetype) => archetype.id === selectedPostId)
    : archetypes.find((archetype) => archetype.id === selectedArchetypeKey);

  const selectedArchetypeEmbedId =
    selectedArchetype?.embed && "id" in selectedArchetype.embed ? selectedArchetype.embed.id : null;

  useEffect(() => {
    if (selectedPostId) {
      setSelectedArchetypeKey(selectedPostId);
    }
  }, [selectedPostId]);

  const {
    data: archetypeData,
    isLoading: isArchetypeLoading,
    isFetching: isArchetypeFetching,
  } = internalApi.useGetCmsPostQuery(selectedArchetypeEmbedId || "", {
    skip: !selectedArchetypeEmbedId,
  });

  return {
    selectedArchetypeKey,
    setSelectedArchetypeKey,
    archetypes,
    selectedArchetype,
    archetypeData,
    isArchetypeLoading,
    isArchetypeFetching,
  };
};
export default useArchetypes;
